import React from 'react'
import { useSelector } from 'react-redux'

import { Badge } from '@material-ui/core'

import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  makeStyles
} from '@material-ui/core'
import { Help as HelpIcon, Update as UpdateIcon } from '@material-ui/icons'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn'
import Feedback from '@material-ui/icons/Feedback'

import { useTranslation } from 'react-i18next'
import {
  getCustomerDomain,
  getCustomerDomainClientArea,
  RootStoreModel,
  toggleSideChangelog,
  toggleSideHelp
} from '../../../../redux'

import { styles } from './header.styles'

export const HeaderMenuMobile: React.FC = () => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const { t } = useTranslation('translation')

  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null)
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
  const customerDomain = getCustomerDomain() || ''
  const customerDomainClientArea = getCustomerDomainClientArea() || ''
  const newRelease = useSelector((state: RootStoreModel) => state.layout.newReleaseNotification)

  const handleSideHelpToggle = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    toggleSideHelp()
    handleMobileMenuClose()
  }, [])

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null)
  }

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget)
  }

  const handleSideChangelogToggle = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    toggleSideChangelog()
  }, [])

  const profile = useSelector((state: RootStoreModel) => state.profile && state.profile)

  const mobileMenuId = 'primary-search-account-menu-mobile'
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem disabled>
        <ListItemIcon>
          <IconButton aria-label="account of current user" color="inherit">
            <AccountCircleIcon />
          </IconButton>
        </ListItemIcon>
        <ListItemText>{profile.user?.name}</ListItemText>
      </MenuItem>
      <a
        className={classes.backToClassicLink}
        href={
          customerDomainClientArea.startsWith('https')
            ? customerDomainClientArea
            : `https://${customerDomainClientArea}`
        }
        target="_blank"
        rel="noreferrer"
      >
        <MenuItem>
          <ListItemIcon>
            <IconButton aria-label={t('header.actions.supportPortal')}>
              <Feedback />
            </IconButton>
          </ListItemIcon>
          <ListItemText>{t('header.actions.supportPortal')}</ListItemText>
        </MenuItem>
      </a>
      <MenuItem onClick={handleSideChangelogToggle}>
        <ListItemIcon>
          <IconButton
            aria-label={t('header.actions.changelogTooltip')}
            onClick={handleSideChangelogToggle}
          >
            <Badge color="primary" variant="dot" invisible={!newRelease}>
              <UpdateIcon />
            </Badge>
          </IconButton>
        </ListItemIcon>
        <ListItemText>{t('header.actions.changelogTooltip')}</ListItemText>
      </MenuItem>
      <MenuItem onClick={handleSideHelpToggle}>
        <ListItemIcon>
          <IconButton aria-label="help" color="inherit">
            <HelpIcon />
          </IconButton>
        </ListItemIcon>
        <ListItemText>{t('header.actions.help')}</ListItemText>
      </MenuItem>
      <MenuItem onClick={profile.logoutHandler}>
        <ListItemIcon>
          <IconButton aria-label="account of current user" color="inherit">
            <ExitToAppIcon />
          </IconButton>
        </ListItemIcon>
        <ListItemText>{t('header.actions.logout')}</ListItemText>
      </MenuItem>
    </Menu>
  )

  return (
    <>
      <IconButton
        aria-label="show more"
        aria-controls={mobileMenuId}
        aria-haspopup="true"
        onClick={handleMobileMenuOpen}
        color="inherit"
      >
        <MoreVertIcon />
      </IconButton>
      {renderMobileMenu}
    </>
  )
}
